<q-tooltip class="bg-white text-blue-darkest" style="border: 1px solid #C2D4FF;"><slot></slot></q-tooltip>